module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.6c8410d0.png";